import React, { useState, useEffect, useRef } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  colors,
  Modal,
  Box,
  Button,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { GoSearch } from "react-icons/go";
import { FaLink } from "react-icons/fa6";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import NoImageFound from "../../assets/images/No-Image-found.png";

const columns = [
  { id: "order_id", label: "ORDER ID", minWidth: 140, align: "center" },
  { id: "order_type", label: "ORDER TYPE", minWidth: 140, align: "center" },
  {
    id: "wholesaler_id",
    label: "WHOLESALER ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: "ryder_id",
    label: "RYDER ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: "retailer_id",
    label: "RETAILER ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: "invoice_amount",
    label: "INVOICE AMOUNT",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: "wholesaler_paid",
  //   label: "WHOLESALER PAID",
  //   minWidth: 170,
  //   align: "center",
  // },
    {
    id: "platform_fee_for_wholesaler",
    label: "PLATFORM FEE FOR WHOLESALER",
    minWidth: 170,
    align: "center",
  },
    {
    id: "platform_fee_retailer",
    label: "PLATFORM FEE FOR RETAILER",
    minWidth: 170,
    align: "center",
  },
  // {
  //   id: "convenience_fee",
  //   label: "CONVENIENCE FEE",
  //   minWidth: 170,
  //   align: "center",
  // },
  { id: "ryder_fee", label: "RYDER FEE", minWidth: 130, align: "center" },
  {
    id: "base_ryder_fee",
    label: "PAID TO RYDER",
    minWidth: 180,
    align: "center",
  },
  {
    id: "gomak_commision",
    // label: "GOMAK COMMISION",
    label: "GOMAK COMMISION FROM RYDER FEE",
    minWidth: 180,
    align: "center",
  },
  { id: "order_status", label: "STATUS", minWidth: 100, align: "center" },
  { id: "paid_by", label: "RYDER FEE PAID BY", minWidth: 150, align: "center" },
  {
    id: "total_amount_paid",
    // label: "TOTAL AMMOUNT PAID",
    label: "TOTAL AMMOUNT TO GOMAK",
    minWidth: 220,
    align: "center",
  },

  {
    id: "created_at",
    label: "INVOICE DATE",
    minWidth: 180,
    align: "center",
  },
  {
    id: "ryder_invoice",
    label: "RYDER INVOCIE",
    minWidth: 180,
    align: "center",
  },
  {
    id: "invoice_summary",
    label: "WHOLESALER INVOCIE",
    minWidth: 180,
    align: "center",
  },
];

function createData(
  wholesaler_id,
  order_type,
  order_id,
  ryder_id,
  retailer_id,
  invoice_amount,
  convenience_fee,
  wholesaler_paid,
  ryder_fee,
  gomak_commision,
  base_ryder_fee,
  status,
  order_status,
  created_at,
  total_amount_paid,
  paid_by,
  invoice_summary,
  ryder_invoice,
) {
  return {
    wholesaler_id,
    order_type,
    ryder_id,
    retailer_id,
    order_id,
    invoice_amount,
    convenience_fee,
    wholesaler_paid,
    ryder_fee,
    base_ryder_fee,
    status,
    order_status,
    gomak_commision,
    created_at,
    total_amount_paid,
    paid_by,
    invoice_summary,
    ryder_invoice,
  };
}

export const WholeTransactionDetails = () => {
  const [toggleModalOpen, setToggleModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);

  const [TransactionList, setTransactionList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(20);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(+event.target.value);
  //   setPage(0);
  // };

  // save table page size in local to save data on page change
  const [page, setPage] = useState(() => {
    const saved = localStorage.getItem("transaction_page");
    return saved ? Number(saved) : 0;
  });

  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const saved = localStorage.getItem("transaction_rowsPerPage");
    return saved ? Number(saved) : 20;
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    localStorage.setItem("transaction_page", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const value = Number(event.target.value);

    setRowsPerPage(value);
    setPage(0);

    localStorage.setItem("transaction_rowsPerPage", value);
    localStorage.setItem("transaction_page", 0);
  };

  const fetchTransactionsList = async (
    pageNumber = 0,
    pageSize = rowsPerPage,
  ) => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // "/admin/wholesaler-transaction-list/"
        `/admin/transaction-list/?page=${pageNumber + 1}&page_size=${pageSize}`,
      );
      console.log("✅ Wholesaler Transactions list response:", res.data);
      if (res.data.results?.status === "success") {
        setTransactionList(res.data.results.data || []);
        setTotalCount(res.data.count || 0);
      } else {
        setError("Failed to fetch Wholesaler Transactions data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Wholesaler Transactions data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchTransactionsList();
  // }, []);

  useEffect(() => {
    fetchTransactionsList(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery]);

  const formatValue = (columnId, value) => {
    if (value === null || value === undefined || value === "") return "--";

    if (
      [
        "invoice_amount",
        "convenience_fee",
        "wholesaler_paid",
        "ryder_fee",
        "base_ryder_fee",
        "gomak_commision",
        "total_amount_paid",
        "platform_fee_for_wholesaler"
      ].includes(columnId)
    ) {
      return `₹ ${parseFloat(value).toFixed(2)}`;
    }

    if (columnId === "order_id") {
      return `#${value}`;
    }

    if (columnId === "wholesaler_id") {
      return `${value}`;
    }

    if (columnId === "created_at") {
      const date = new Date(value);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    }

    return value;
  };

  const filteredData = TransactionList.filter(
    (row) =>
      row.order_id
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      row.wholesaler_id
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      row.ryder_id
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      row.retailer_id
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()),
  );

  // ✅ Generate wholesaler invoice link
  const fetchWholesalerInvoice = async (orderitem_id) => {
    try {
      const res = await axiosInstance.get(
        `/wholesaler/convenience-fee-pdf/${orderitem_id}/`,
      );
      if (res.data?.status === "success" && res.data.data) {
        window.open(res.data.data, "_blank");
      } else {
        toast.error("Failed to generate wholesaler invoice link.");
      }
    } catch (err) {
      toast.error("Error generating wholesaler invoice link.");
    }
  };

  // ✅ Generate Ryder invoice link
  const fetchRyderInvoice = async (orderitem_id) => {
    try {
      const res = await axiosInstance.get(`/invoice-pdf/${orderitem_id}/`);
      if (res.data?.status === "success" && res.data.data) {
        window.open(res.data.data, "_blank");
      } else {
        toast.error("Failed to generate Ryder invoice link.");
      }
    } catch (err) {
      toast.error("Error generating Ryder invoice link.");
    }
  };

  const tableContainerRef = useRef(null);
  const scrollLeft = () => {
    tableContainerRef.current?.scrollBy({
      left: -300,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    tableContainerRef.current?.scrollBy({
      left: 300,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div>
        <div className="admin-top-container">
          <div className="admin-listText"> Transactions Details</div>
          {/* <div>
                <select
                  className="listAdmin-showRecords"
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                >
                  <option value={20}>Show No of Records</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={500}>500</option>
                  <option value={1000}>1000</option>
                  <option value={2000}>2000</option>
                  <option value={5000}>5000</option>
                </select>
              </div> */}
          <div className="search-container">
            <div className="nav-search ">
              <span className="search-icons">
                <GoSearch />
              </span>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer
            sx={{ maxHeight: 440 }}
            ref={tableContainerRef}
            className="Table-container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <TableRow
                      className="table-row"
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        const orderStatus = row.order_status?.toLowerCase();

                        // Conditional logic for buttons
                        if (column.id === "invoice_summary") {
                          const showButton =
                            [
                              "payment_success",
                              "ready_for_delivery",
                              "out_for_delivery",
                              "delivered",
                              "accepted_by_ryder",
                            ].includes(orderStatus) &&
                            Number(row.wholesaler_paid) > 0;
                          return (
                            <TableCell align={column.align} key={column.id}>
                              {showButton ? (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    fetchWholesalerInvoice(row.orderitem_id)
                                  }
                                >
                                  INVOICE
                                </Button>
                              ) : (
                                "--"
                              )}
                            </TableCell>
                          );
                        }

                        if (column.id === "ryder_invoice") {
                          const showButton = orderStatus === "delivered";
                          return (
                            <TableCell align={column.align} key={column.id}>
                              {showButton ? (
                                <Button
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  onClick={() =>
                                    fetchRyderInvoice(row.orderitem_id)
                                  }
                                >
                                  INVOICE
                                </Button>
                              ) : (
                                "--"
                              )}
                            </TableCell>
                          );
                        }

                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={`${column.id}-Wholesalercolumn tableCelldata`}
                            onClick={
                              column.id === "order_id"
                                ? () =>
                                    navigate(
                                      // `/transaction-wholesaler-details/${row.order_id}`
                                      `/view-whole-transactions/${row.orderitem_id}`,
                                    )
                                : undefined
                            }
                            sx={{
                              color:
                                column.id === "order_status"
                                  ? value === "Closed"
                                    ? "green"
                                    : "red"
                                  : "inherit",
                              cursor:
                                column.id === "order_id"
                                  ? "pointer"
                                  : "default",
                              color: column.id === "order_id" ? "#4184D1" : "",
                            }}
                          >
                            {formatValue(column.id, value)}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={columns.length}
                      align="center"
                      style={{ padding: "40px 0" }}
                    >
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TablePagination
            rowsPerPageOptions={[20, 30, 50, 100, 500, 1000, 2000, 5000, 10000]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          /> */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
            }}
          >
            <Box>
              <IconButton onClick={scrollLeft}>
                <ChevronLeftIcon />
              </IconButton>
              <IconButton onClick={scrollRight}>
                <ChevronRightIcon />
              </IconButton>
            </Box>

            <TablePagination
              rowsPerPageOptions={[
                20, 30, 50, 100, 500, 1000, 2000, 5000, 10000,
              ]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Paper>
      </div>

      <Modal open={toggleModalOpen} onClose={() => setToggleModalOpen(false)}>
        <Box
          sx={{
            position: "relative",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* ❌ Close Button */}
          <button
            onClick={() => setToggleModalOpen(false)}
            style={{
              position: "absolute",
              top: 10,
              right: 15,
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>

          <h3 id="toggle-status-title">INVOICE SUMMARY</h3>
          <hr />
          <div style={{ textAlign: "center" }}>
            {imageUrl ? (
              <img
                src={imageUrl || NoImageFound}
                alt="Document"
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop
                  e.target.src = NoImageFound;
                }}
                style={{
                  width: "100%",
                  maxHeight: "400px",
                  objectFit: "contain",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
              />
            ) : (
              <div>No document to display.</div>
            )}
          </div>
          <hr />
        </Box>
      </Modal>
    </>
  );
};
